import { useIntl } from '@capsicum/common';
import { amlQuestionnaireReducerAtom } from '@capsicum/features/regulations/shared';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

export const useAmlPep = () => {
	const { $t } = useIntl();
	const [questionValue, setQuestionValue] = useState<boolean>(false);
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	const options = [
		{
			id: false,
			label: $t('amlQuestionnaire.fifthStep.option1')
		},
		{
			id: true,
			label: $t('amlQuestionnaire.fifthStep.option2')
		}
	];

	useEffect(() => {
		dispatch({ data: { pep: questionValue }, type: 'UPDATE_FORM_DATA' });
	}, [questionValue]);

	return {
		options,
		questionValue,
		setQuestionValue
	};
};
